/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-floor-left-and-right.vue?vue&type=template&id=e307bbf0&scoped=true"
import script from "./pc-floor-left-and-right.vue?vue&type=script&lang=js"
export * from "./pc-floor-left-and-right.vue?vue&type=script&lang=js"
import style0 from "./pc-floor-left-and-right.vue?vue&type=style&index=0&id=e307bbf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e307bbf0",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
